 <div class="container-fluid mx-auto mt-3 mb-3 py-3 border">
<div class="row">
  <div class="col-12 mb-4">
    Thank you. As next step, please wait for your invitees to post images.
  </div>  
   <div class="col-12 mb-4">
    <strong>{{dbService.selectedEvent.title}}</strong> is active between {{dbService.selectedEvent.fromdate}} to {{dbService.selectedEvent.todate}}
  </div>  
  <div class="col-12 mb-4">
    After the images are posted, please revisit https://www.ceeyu.us and select Publish task.
  </div> 
  <div class="col-12 mb-4">
    <div class="row mx-auto text-center bg-info">Publish task allows you to:</div>
    <div class="row text-center"> a) preview and approve images </div>
    <div class="row text-center"> b) extend event active dates </div>
  </div>  
  
  <div>
    <div><button class="row mt-2 mb-4 btn btn-primary" type="button" (click)="addAttendees()">Invite Friends and Family</button></div>
  </div>

  <div class="col-12 mx-auto text-center bg-info">
    You may close this browser.
  </div>    
</div>
